import { Plus, X } from "lucide-react";
import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "src/components/ui/button";
import { Select, theme } from "antd";
import { Badge } from "src/components/ui/badge";

export const SelectMembers = ({
  users = [],
  record,
  setRecord,
  errors,
}) => {
  const roles = [
    { value: "leader", label: "قائد" },
    { value: "member", label: "عضو" },
  ];

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRole, setSelectedRole] = useState("member");
  const availableUsers = users.filter(
    (user) => !record.users?.some((member) => member.id === user.id)
  );

  const addMember = () => {
    if (!selectedUser) {
      toast("خطأ", {
        description: "الرجاء اختيار عضو",
      });
      return;
    }

    const newMember = {
      id: selectedUser,
      role: selectedRole,
    };

    setRecord((prev) => ({
      ...prev,
      users: [...prev.users, newMember],
    }));

    // Reset selection
    setSelectedUser(null);
  };

  // Remove a member from the list
  const removeMember = (memberId) => {
    setRecord((prev) => ({
      ...prev,
      users: prev.users.filter((member) => member.id !== memberId),
    }));
  };

  // Get user name by ID
  const getUserName = (userId) => {
    return users.find((user) => user.id === userId)?.name || `User ${userId}`;
  };

  // Get role label by value
  const getRoleLabel = (roleValue) => {
    return roles.find((role) => role.value === roleValue)?.label || roleValue;
  };

  return (
    <>
      {/* Current members list */}
      <div className="mb-3">
        <div className="text-sm text-muted-foreground mb-2">
          الأعضاء المضافين:
        </div>
        <div className="flex flex-wrap gap-2">
          {record?.users?.length === 0 ? (
            <div className="text-sm text-muted-foreground">
              لم يتم إضافة أعضاء بعد
            </div>
          ) : (
            record?.users?.map((member) => (
              <Badge
                key={member.id}
                variant="secondary"
                className="flex items-center gap-1 py-1 px-3"
              >
                <span>{getUserName(member.id)}</span>
                <span className="text-xs text-muted-foreground">
                  ({getRoleLabel(member.role)})
                </span>
                <X
                  className="h-3 w-3 cursor-pointer ml-1"
                  onClick={() => removeMember(member.id)}
                />
              </Badge>
            ))
          )}
        </div>
      </div>

      {/* Select Members */}
      <div className="space-y-2 z-10">
        <label className="block font-medium">الأعضاء</label>
        <div className="flex items-end gap-2">
          <div className="flex-1">
            <label className="block text-sm mb-1">اختر عضو</label>
            <Select
              placeholder="اختر عضو"
              value={selectedUser}
              onChange={setSelectedUser}
              style={{ width: "100%" }}
              options={availableUsers.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              // These are the key properties to fix touchability in Sheet
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownStyle={{ zIndex: 9999 }}
              virtual={false}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm mb-1">اختر دور</label>
            <Select
              placeholder="اختر دور"
              value={selectedRole}
              onChange={setSelectedRole}
              style={{ width: "100%" }}
              options={roles}
              // These are the key properties to fix touchability in Sheet
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              dropdownStyle={{ zIndex: 9999 }}
              virtual={false}
            />
          </div>
          <Button size="sm" onClick={addMember} disabled={!selectedUser}>
            <Plus className="h-4 w-4" />
          </Button>
        </div>

        {errors?.members && (
          <p className="text-red-500 font-semibold text-sm">
            {errors.members[0]}
          </p>
        )}
      </div>
    </>
  );
};
